import { _x } from '@wordpress/i18n'
import { trigger } from '../../../assets/frontend/js/easterEggs/engine'
import { showMessage } from '../../../assets/frontend/js/easterEggs/effects/message'
import { wobbleElement } from '../../../assets/frontend/js/easterEggs/effects/wobble'

const clicksPerRound = 7
// the egg only counts as found after the full 7x7 - the earlier rounds
// wobble and taunt, but don't award anything
const roundsToFind = 7
// clicks further apart than this reset the combo (and the round streak)
const maxClickGapMs = 10000
const storageKey = 'icf-easter-eggs-logo'

type LogoState = { count: number; round: number; last: number }

// resolved at call time so the wp-i18n locale data is guaranteed to be loaded
function getMessages(): string[] {
  return [
    _x('You found an easter egg!', 'Logo Easter Egg Round 1', 'icf'),
    _x(
      'Seven more? You really like this logo.',
      'Logo Easter Egg Round 2',
      'icf'
    ),
    _x(
      'Third round. The logo is getting dizzy.',
      'Logo Easter Egg Round 3',
      'icf'
    ),
    _x(
      'Round four. We admire your dedication.',
      'Logo Easter Egg Round 4',
      'icf'
    ),
    _x(
      'Round five. Honestly, there is nothing new here.',
      'Logo Easter Egg Round 5',
      'icf'
    ),
    _x(
      'Round six. One more round and we tell you a secret.',
      'Logo Easter Egg Round 6',
      'icf'
    ),
    // TODO: verify Bible verse wording per locale
    _x(
      '"How often should I forgive? Seven times?" - "Not seven times, but seventy times seven." (Matthew 18:21-22)',
      'Logo Easter Egg Round 7',
      'icf'
    )
  ]
}

function readState(): LogoState {
  try {
    const parsed: unknown = JSON.parse(
      sessionStorage.getItem(storageKey) ?? ''
    )
    if (typeof parsed === 'object' && parsed !== null) {
      const state = parsed as Partial<LogoState>
      return {
        count: state.count ?? 0,
        round: state.round ?? 0,
        last: state.last ?? 0
      }
    }
  } catch {
    // no stored state yet, or storage unavailable
  }
  return { count: 0, round: 0, last: 0 }
}

function writeState(state: LogoState) {
  try {
    sessionStorage.setItem(storageKey, JSON.stringify(state))
  } catch {
    // storage unavailable - the round streak just won't survive page loads
  }
}

// desktop: the big footer logo; mobile: the small inline logo in the
// global-footer copyright line (both render together via parts/footer.html)
for (const logo of document.querySelectorAll<HTMLElement>(
  '.wp-block-yellowtree-footer .brand-image, #global-footer .brand-image'
)) {
  logo.addEventListener('click', () => {
    const state = readState()
    const now = Date.now()
    if (now - state.last > maxClickGapMs) {
      state.count = 0
      state.round = 0
    }
    state.count++
    state.last = now

    if (state.count >= clicksPerRound) {
      state.count = 0
      state.round++

      const finished = state.round >= roundsToFind

      wobbleElement(logo, { intensity: Math.min(state.round, roundsToFind) })
      const messages = getMessages()
      const message = messages[Math.min(state.round, messages.length) - 1]
      if (message) {
        showMessage({
          text: message,
          // the verse round gets a warmer icon and more reading time
          icon: finished ? 'fa-face-smile-hearts' : 'fa-party-horn',
          durationMs: finished ? 9000 : 5000
        })
      }
      if (finished) trigger('logo-clicks', 'footer')
    }

    writeState(state)
  })
}
